export default __webpack_public_path__ + "static/media/profile-side-img.41110fb3.svg";